import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import ProtectedRoute from '@/components/auth/ProtectedRoute';
import MainNavigation from './components/layout/MainNavigation';
import ScrollToTop from './components/common/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Works from './pages/Works';
import WorkDetail from './pages/WorkDetail';
import Contact from './pages/Contact';
import Recruit from './pages/Recruit';
// Admin pages
import AdminLogin from './pages/admin/Login';
import AdminDashboard from './pages/admin/Dashboard';
import ProjectEditor from './pages/admin/ProjectEditor';
function App() {
    return (<AuthProvider>
      <Routes>
        {/* Public routes */}
        <Route path='/*' element={<>
            <MainNavigation />
            <ScrollToTop />
            <Routes>
              <Route path='/' element={<Home />}/>
              <Route path='/about' element={<About />}/>
              <Route path='/services' element={<Services />}/>
              <Route path='/works' element={<Works />}/>
              <Route path='/works/:slug' element={<WorkDetail />}/>
              <Route path='/contact' element={<Contact />}/>
              <Route path='/recruit' element={<Recruit />}/>
            </Routes>
          </>}/>
        
        {/* Admin routes */}
        <Route path='/admin/login' element={<AdminLogin />}/>
        <Route path='/admin' element={<ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>}/>
        <Route path='/admin/projects/:id/edit' element={<ProtectedRoute>
            <ProjectEditor />
          </ProtectedRoute>}/>
        <Route path='/admin/projects/new' element={<ProtectedRoute>
            <ProjectEditor />
          </ProtectedRoute>}/>
      </Routes>
    </AuthProvider>);
}
export default App;
